import type { IBeneficiary } from "@/modules/beneficiary/common/types";
import type { IError } from "@/shared/common/types";
import { PageWidgetTemplate } from "@/shared/components";
import { useTranslation } from "react-i18next";

import { BeneficiaryItem } from "./BeneficiaryItem";

interface Props {
  type: string;
  beneficiaryName: string;
  activeId?: string;
  beneficiaries?: IBeneficiary[];
  isFetching: boolean;
  isError: boolean;
  error?: IError;
  refetch: () => void;
  onItemClick: (beneficiary: IBeneficiary) => void;
  onDeleteItem?: (id: string) => void;
}

export const Beneficiaries = ({
  type,
  beneficiaryName,
  activeId,
  beneficiaries,
  isFetching,
  isError,
  error,
  refetch,
  onItemClick,
  onDeleteItem,
}: Props) => {
  const { t } = useTranslation();

  return (
    <PageWidgetTemplate
      isEmpty={!beneficiaries?.length}
      isFetching={isFetching}
      isError={isError}
      error={error as IError}
      refetch={refetch}
      emptyTitle={t(beneficiaryName ? "beneficiary.searchEmpty.title" : "beneficiary.noBeneficiariesTitle")}
      emptySubtitle={t(beneficiaryName ? "beneficiary.searchEmpty.description" : "beneficiary.noBeneficiariesSubtitle")}
    >
      {beneficiaries?.map((beneficiary, i) => (
        <BeneficiaryItem
          key={beneficiary.id}
          {...beneficiary}
          type={type}
          index={i}
          isActive={beneficiary.id === activeId}
          refetch={refetch}
          onItemClick={(id) => {
            const found = beneficiaries.find((b) => b.id === id);
            if (found) onItemClick(found);
          }}
          onDelete={onDeleteItem}
        />
      ))}
    </PageWidgetTemplate>
  );
};
